<template>
  <div v-if="consignee" class="row">
    <div id="consignee-info">
      <div class="mh-200px row">
        <div class="col-6 po">
          <h3>Recipient</h3>
        </div>
        <div class="col-6 p-0 align-middle">
          <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">                     
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  class="float-left align-middle"
                  v-if="isManage && barrelId"
                  @click.prevent="printConsignee"
                >
                  mdi-printer
                </v-icon>
              </template>
              <span>Print Recipient Information</span>
            </v-tooltip>
        </div>
        <dl class="row">
          <div class="col">
            <dt class="heading">Name</dt>
            <dd>
              {{ getConsigneeName(consignee) }}
            </dd>
          </div>
          <div class="col">
            <dt class="heading">Contact Number</dt>
            <dd><em>{{ consignee.ContactNumber }}</em></dd>
          </div>
          <div class="col">
            <dt class="heading">TRN</dt>
            <dd><em>{{ consignee.Trn }}</em></dd>
          </div>
          <div class="row pl-4">
            <dt class="heading">Email</dt>
            <dd><em>{{ consignee.Email }}</em></dd>
          </div>
          <div class="row pl-4">
            <dt class="heading">Address</dt>
            <dd>
              <em>{{ formatAddress(consignee.Address) }}</em>
            </dd>
          </div>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
  name: "ConsigneeInfo",
  props: {
    consignee: { type: Object, required: true },
    barrelId: { type: String },
  },
  methods: {
    getConsigneeName(consignee) {
      return `${consignee.FirstName} ${consignee.LastName}`;
    },
    formatAddress(address) {
      let addrString = `${address?.Line1}, `;
      if (address?.Line2) addrString += `${address?.Line2}, `;
      addrString += `\n${address?.Town}, ${address?.Parish},\n ${address?.Country}`;
      return addrString;
    },
    printConsignee() {
      const prtHtml = document.getElementById("consignee-info").innerHTML;

      // Get all stylesheets HTML
      let stylesHtml = "";
      for (const node of document.querySelectorAll(
        'link[rel="stylesheet"], style'
      )) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "width=600,height=800,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body style="padding:20px;max-height=200px;max-width=400px !important;">
    ${prtHtml}
  </body>
</html>`);
      setTimeout(() => {
        WinPrint.document.close();
        WinPrint.focus();
        WinPrint.print();
        WinPrint.close();
      }, 1000);
    },
  },
  computed: {
    isManage() {
      return this.$route.name === "Manage";
    },
  },
});
</script>

<style>
.heading{
  text-decoration: underline;
  font-weight: bold;
}
</style>
